<template>
  <div class="event-detail">
    <content-loader v-if="$apollo.loading" title="Event" />
    <div v-else>
      <event-page-header :event="eventDetail"></event-page-header>
      <div class="container">
        <div class="buttons-row">
          <cs-tag class="tag"> {{ eventDetail.group.type }} Event </cs-tag>
          <cs-button
            :href="eventDetail.event_url"
            target="_blank"
            variant="primary"
            fill="solid"
            >View on Meetup</cs-button
          >
        </div>
        <div class="row">
          <div class="col-left">
            <div class="card">
              <div class="description">
                <p class="cs-textstyle-section-heading">
                  {{ eventDetail.title }}
                </p>
                <div
                  class="cs-textstyle-paragraph"
                  v-html="eventDetail.description"
                ></div>
              </div>
            </div>
          </div>

          <div class="col-right">
            <div class="card">
              <event-info-card
                class="col-md-7 col-lg-12 order-3 order-md-2 order-lg-3"
                :event="eventDetail"
              />
            </div>
          </div>
        </div>
        <more-events-section />
      </div>
    </div>
  </div>
</template>

<script>
import getEvent from '@/newgql/GetEvent.gql';
import ContentLoader from '@/components/global/ContentLoader';
import EventPageHeader from '@/components/events/EventPageHeader';
import EventInfoCard from '@/components/events/EventInfoCard';
import VenueCard from '@/components/events/VenueCard';
import AppSocialSharing from '@/components/global/AppSocialSharing';
import MoreEventsSection from '@/components/events/MoreEventsSection.vue';

export default {
  name: 'event-detail',

  components: {
    ContentLoader,
    EventPageHeader,
    MoreEventsSection,
    VenueCard,
    EventInfoCard,
    AppSocialSharing
  },

  apollo: {
    event: {
      query: getEvent,
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    }
  },
  computed: {
    eventDetail() {
      return this.event.length ? this.event[0] : {};
    },
    locationDetails() {
      return {
        ...this.eventDetail.city
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0px 20px 10px;
  height: 100%;

  @include media-breakpoint-up(lg) {
    padding: 0px 20px 30px;
  }
}

.col-left {
  @include make-col-ready();
  @include make-col(12);
  @include media-breakpoint-up(lg) {
    @include make-col(7.5);
    padding-right: 0;
  }
}

.col-right {
  @include make-col-ready();
  @include make-col(12);
  @include media-breakpoint-up(lg) {
    @include make-col(4.5);
    padding-left: 0;
  }

  .organiser {
    margin-bottom: 20px;
  }
}

.social-media-sharing {
  /deep/ .card {
    background-color: #ffffff;
  }

  &.lg-show {
    display: none;
    @include media-breakpoint-up(lg) {
      display: block;
    }
  }

  &.lg-hide {
    display: block;
    @include media-breakpoint-up(lg) {
      display: none;
    }
  }
}

.buttons-row {
  padding: 20px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.buttons-row .tag {
  height: fit-content;
  --cs-tag-color: #87939b;
  --cs-tag-texcolor: #ffffff;
}

.description {
  margin-bottom: 0;
  color: var(--cs-gray-06);
  @include media-breakpoint-up(lg) {
    margin-bottom: 50px;
  }
  .text {
    font-size: 15px;
    line-height: 27px;
  }
}

.event-detail {
  padding-bottom: 40px;
}

.company-info .company-card {
  margin-bottom: 25px;
}

.city {
  margin-bottom: 10px;
  svg {
    margin-right: 4px;
    fill: #505b64;
    width: 18px;
    height: 18px;
  }
  span {
    color: #505b64;
    vertical-align: middle;
  }
}
</style>
